import { render, staticRenderFns } from "./AddTransferProducts.vue?vue&type=template&id=2ca0c48e"
import script from "./AddTransferProducts.vue?vue&type=script&lang=js"
export * from "./AddTransferProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports